import { initialPaginationState } from './state'

export const updatePaginationMutation = (key = 'pagination') => (state, payload) => {
  const { page, lastPage, total, perPage, search, ids } = payload;

  state[key] = {
    page,
    lastPage,
    total,
    perPage,
    search,
    ids
  }
}

export const resetPaginationMutation = (key = 'pagination') => (state) => {
  state[key] = initialPaginationState();
}

export const paginationMutations = (key = 'pagination') => {
  return {
    updatePagination: updatePaginationMutation(key),
    resetPagination: resetPaginationMutation(key),
  }
}
